exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-secure {\n  background-image: url(/assets/img/secure-bg.jpg);\n  background-size: cover;\n  background-position: center center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/authentication/signin/signin.component.scss
// module id = ../../../../../src/app/authentication/signin/signin.component.scss
// module chunks = main